import { Table } from "antd";
import React from "react";

function buildSoftwareData(softwareVersions) {
  if (!softwareVersions) return [];
  let data = [];
  let keyCounter = 1;

  Object.entries(softwareVersions).forEach(([section, params]) => {
    // Section header
    data.push({
      key: `header-${keyCounter++}`,
      attribute: section,
      value: "",
      isHeader: true,
    });

    params.forEach((paramObj) => {
      const paramName = Object.keys(paramObj)[0];
      const paramValue = paramObj[paramName];
      data.push({
        key: keyCounter++,
        attribute: paramName,
        value: paramValue,
      });
    });
  });

  return data;
}

const SoftwareVersions = ({ selectedJob, softwareVersions }) => {
  console.log("selectedJob", selectedJob);

  const softwareData = buildSoftwareData(softwareVersions);

  const columns = [
    {
      title: "",
      dataIndex: "attribute",
      key: "attribute",
      render: (text, record) => {
        if (record.isHeader) {
          return <span style={{ color: "#e03540" }}>{text}</span>;
        }
        return text;
      },
      onCell: (record) => {
        if (record.isHeader) {
          return { colSpan: 2 };
        }
        return {};
      },
    },
    {
      title: "",
      dataIndex: "value",
      key: "value",
      onCell: (record) => {
        if (record.isHeader) {
          return { colSpan: 0 };
        }
        return {};
      },
    },
  ];

  const calcHeight = -150;
  const tableHeight = `calc(${calcHeight}px + 100vh)`;
  return (
    <div
      className="software-versions-table"
      style={{
        height: tableHeight,
        position: "relative",
      }}
    >
      <Table
        columns={columns}
        dataSource={softwareData}
        pagination={false}
        bordered={false}
        className="welding-parameters-table"
        showHeader={false}
        scroll={{ y: tableHeight }}
      />
    </div>
  );
};

export default SoftwareVersions;
